import { useForm } from "react-hook-form";

import { GenericLandingCard, SetPasswordForm } from "../components";
import { SetPasswordBtn } from "components/buttons";

export const SetPasswordPage = () => {
  const { control, handleSubmit, watch, trigger } = useForm({
    mode: "onChange",
    defaultValues: {
      password: "",
      confirmPassword: "",
      token: "",
    },
    shouldFocusError: false,
  });
  return (
    <GenericLandingCard
      rightColumn={
        <SetPasswordForm
          control={control}
          watch={watch}
          trigger={trigger}
          handleSubmit={handleSubmit}
        />
      }
      rightInteraction={<SetPasswordBtn />}
    ></GenericLandingCard>
  );
};
